import React from "react";

const LeftServiceButtonImgSection1 = (props) => {
  return <img className="w-28 lg:w-[30%] rounded-2xl p-1" src={props.image} alt="" />;
};

export default LeftServiceButtonImgSection1;
